import { isLastItemInArray } from './utils';

export default {
  methods: {
    /**
     * @param {string} key
     * @param {{text: string; value: string}} option
     */
    processSingleSelect(key, option, optionProperty = 'value') {
      if (!option) {
        this.form[key] = null;
        return;
      }
      this.form[key] = option[optionProperty];
    },
    /**
     * @param {string} key
     * @param {{text: string; value: string}[]} options
     */
    processMultipleSelect(key, options, optionProperty = 'value') {
      if (!options || (Array.isArray(options) && !options.length)) {
        this.form[key] = [];
        return;
      }

      if (!Array.isArray(options)) {
        console.warn('Emitted selection is not any array');
        return;
      }

      this.form[key] = options.map((option) => option[optionProperty]);
    },

    getSelectOptions(options, forLocalisedOptions = false) {
      const self = this;
      let selectionOptions = [];
      if (typeof options === 'function') {
        selectionOptions = options.bind(self)(
          forLocalisedOptions ? self.$i18next.language : undefined
        );
      }

      if (Array.isArray(options)) {
        selectionOptions = options;
      }

      // Potentially translate options
      return (
        selectionOptions?.map?.((innerOption) => {
          if (typeof innerOption === 'string') {
            return this.$maybeT(innerOption);
          }
          if (typeof innerOption === 'object') {
            return this.translateObj(innerOption);
          }
          return innerOption;
        }) ?? []
      );
    },

    isLastItemInArray(items, index) {
      return isLastItemInArray(items, index);
    },

    shouldDisableMultiRowFormDeleteBtn(rows, index) {
      if (!Array.isArray(rows)) {
        throw new Error('"rows" should be an array');
      }

      if (rows.length > 1) {
        return false;
      }

      return index === 0;
    },
  },
};
